import { Component } from '@angular/core';
import { ButtonComponent } from '../../components/boutons/button/button.component';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ResponsiveService } from '../../services/reponsive.service';
import { AsyncPipe, NgClass } from '@angular/common';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { ClientActions } from '../../store/client/client.actions';

@Component({
  selector: 'app-payment-success',
  imports: [ButtonComponent, RouterLink, TranslateModule, NgClass, AsyncPipe],
  templateUrl: './payment-success.component.html',
  styleUrl: './payment-success.component.scss'
})
export class PaymentSuccessComponent {
  constructor(
    public responsiveService: ResponsiveService,
    private store:Store
  ) {
    this.store.dispatch(ClientActions.loadClient())
   }
  smallScreen$: Observable<boolean> = this.responsiveService.small$;
  mediumScreen$: Observable<boolean> = this.responsiveService.desktop$;
  largeScreen$: Observable<boolean> = this.responsiveService.largeDesktop$;
}